import React from "react";
import CollegePageContainer from "../../Container/CollegePageContainer";
import JobListingForm from "./JobListingForm";
import ConfirmDelete from "./ConfirmDelete";
import { connect } from "react-redux";
import { withRouter, Prompt } from "react-router-dom";
import { createUserObject } from "../../Profile/profile.utils";
import { API } from "../../../API";
import { notify } from "react-notify-toast";
import { getListingData, getDays, validateForm } from "../utils";
import UnsavedChangesPopup from "../../../Components/UnsavedChangesPopup/UnsavedChangesPopup";

class EditListing extends React.Component {
  // previous_state = this.props.location.state || {
  //   days: [],
  //   responsibilities: [],
  //   benefits: [],
  //   tags: createUserObject({ can_delivers: {} }, true),
  //   interview_requested: true
  // };

  state = {
    _id: "",
    title: "",
    level: "",
    is_vet: false,
    qual_name: "",
    course_code: "",
    location: this.props.campuses.length ? this.props.campuses[0]._id : "",
    online: false,
    delivery_mode: "online_home",
    weekly_hours: 0,
    monday: false,
    tuesday: false,
    wednesday: false,
    thursday: false,
    friday: false,
    saturday: false,
    sunday: false,
    flexible_days: false,
    start_date: null,
    end_date: null,
    close_date: null,
    tags: {},
    description: "",
    responsibility_1: "",
    responsibility_2: "",
    responsibility_3: "",
    benefit_1: "",
    benefit_2: "",
    benefit_3: "",
    expertise_1: "",
    expertise_2: "",
    expertise_3: "",
    salary_type: "",
    salary_min: 0,
    salary_max: 0,
    salary_unit: 0,
    instant_hire: false,
    org_pro_visible: false,
    status: "draft",
    display_salary: true,
    salary_display_option: "",
    no_of_roles: 1,
    is_dirty: false,
    selected_tags: [],
    qualificationList: [],
    levels: [],
    various_campus: false,
    display_various_dates: false,
  };

  updateState = (listing_data) => {
    const days = listing_data.days || [];
    const responsibilities = listing_data.responsibilities || [];
    const benefits = listing_data.benefits || [];
    const expertise = listing_data.expertise || [];
    const tags = listing_data.tags || {
      elt: [],
      bsb: [],
      chc: [],
      fns: [],
      fsk: [],
      shb: [],
      ict: [],
      sit: [],
      tech: []
    };
    let salary_type = listing_data.salary_type;
    if (!salary_type) {
      // console.log("no salary type")
      if (listing_data.salary_unit) {
        salary_type = "annual_salary";
      } else if (listing_data.hourly_rate_unit) {
        salary_type = "hourly_salary";
      }
    }

    // console.log(salary_type)

    return {
      _id: listing_data._id || "",
      title: listing_data.title || "",
      level: listing_data.level || "",
      is_vet: listing_data.is_vet || false,
      qual_name: listing_data.qual_name || "",
      course_code: listing_data.course_code || "",
      location: listing_data.location || "",
      online: listing_data.online || false,
      delivery_mode: listing_data.delivery_mode || "online_home",
      weekly_hours: listing_data.weekly_hours || 0,
      monday: days.includes("monday"),
      tuesday: days.includes("tuesday"),
      wednesday: days.includes("wednesday"),
      thursday: days.includes("thursday"),
      friday: days.includes("friday"),
      saturday: days.includes("saturday"),
      sunday: days.includes("sunday"),
      flexible_days: days.includes("flexible_days"),
      start_date: listing_data.start_date
        ? new Date(listing_data.start_date)
        : null,
      end_date: listing_data.end_date ? new Date(listing_data.end_date) : null,
      close_date: listing_data.close_date
        ? new Date(listing_data.close_date)
        : null,
      tags: tags,
      description: listing_data.description || "",
      responsibility_1: responsibilities[0] || "",
      responsibility_2: responsibilities[1] || "",
      responsibility_3: responsibilities[2] || "",
      benefit_1: benefits[0] || "",
      benefit_2: benefits[1] || "",
      benefit_3: benefits[2] || "",
      expertise_1: expertise[0] || "",
      expertise_2: expertise[1] || "",
      expertise_3: expertise[2] || "",
      salary_type: salary_type,
      salary_min:
        (salary_type === "hourly_salary"
          ? listing_data.hourly_rate_min
          : listing_data.salary_min) || 0,
      salary_max:
        (salary_type === "hourly_salary"
          ? listing_data.hourly_rate_max
          : listing_data.salary_max) || 0,
      salary_unit:
        (salary_type === "hourly_salary"
          ? listing_data.hourly_rate_unit
          : listing_data.salary_unit) || 0,
      instant_hire: !listing_data.interview_requested || false,
      org_pro_visible: listing_data.org_pro_visible,
      status: listing_data.status,
      display_salary: !listing_data.salary_display_option,
      salary_display_option: listing_data.salary_display_option,
      no_of_roles: listing_data.no_of_roles || 1,
      selected_tags: listing_data.selected_tags
    };
  };

  componentDidMount() {
    let listingState = {};
    if (this.props.location.state) {
      listingState = this.updateState(this.props.location.state);
      this.setState(listingState);
    } else {
      API.getListingById(this.props.match.params.id)
        .then((res) => {
          listingState = this.updateState(res.data.listing);
          this.setState(listingState);
        })
        .catch((err) => {
          console.log(err.response);
          notify.show("Error retrieving listing");
        });
    }

    API.getQualificationList().then(result => {
      const qualifications = result?.data?.data

      let levels = []
			let levelPriorities = []
			qualifications.filter(item => item.type === 'vet').forEach((item => {
				const subQualifications = item.qualifications
				subQualifications.forEach(ele => {
					if (!levels.includes(ele.level) && ele.level?.length) {
						levels.push(ele.level)
						levelPriorities.push({
							name: ele.level,
							priority: ele.priority
						})
					}
					else if(levels.includes(ele.level) && ele.level?.length && ele.priority) {
						const itemIndex = levelPriorities.findIndex(item => item.name === ele.level)
						levelPriorities = [
						  ...levelPriorities.slice(0, itemIndex),
						  {
							name: ele.level,
							priority: ele.priority
						  },
						  ...levelPriorities.slice(itemIndex + 1)
						]
					}
				})
			}))

			levels.sort((a, b) => {
				const priorityA = levelPriorities.find(item => item.name === a)?.priority || 0;
				const priorityB = levelPriorities.find(item => item.name === b)?.priority || 0;
				return priorityA - priorityB;
			})

      this.setState({
        qualificationList: qualifications,
        levels
      })
    })
  }

  handleFormFieldChange = (e) => {
    this.setState({
      [e.target.id]: e.target.value,
      is_dirty: true,
    });
  };

  handleCheckboxChange = (e) => {
    let newState = {
      [e.target.id]: e.target.checked,
      is_dirty: true,
    };

    if (e.target.id === "display_salary") {
      newState.salary_type = e.target.checked ? "annual_salary" : "";
      newState.salary_display_option = !e.target.checked ? "Award Rates" : "";
    }

    if (e.target.id === "is_elt") {
      newState.is_vet = false;
    }

    this.setState({
      ...this.state,
      ...newState,
    });
  };

  handleDateChange = (date, field) => {
    this.setState({
      [field]: date,
      is_dirty: true,
    });
  };

  handleDeliveryModeChange = (e) => {
    this.setState({
      delivery_mode: e.target.id,
      is_dirty: true,
    });
  };

  handleRemunerationChange = (e) => {
    this.setState({
      salary_type: e.target.value,
      is_dirty: true,
    });
  };

  handleCurrencyValueChange = (name, value) => {
    this.setState({
      [name]: Number(value) || 0,
      is_dirty: true,
    });
  };

  handleTagsChange = (tags) => {
    this.setState({
      selected_tags: tags,
      is_dirty: true,
    });
  };

  handleRadioChange = (e) => {
    this.setState({
      [e.target.name]: e.target.title,
      is_dirty: true,
    });
  };

  getDays = () => {
    let days = [];
    [
      "monday",
      "tuesday",
      "wednesday",
      "thursday",
      "friday",
      "saturday",
      "sunday",
    ].forEach((day) => {
      if (this.state[day]) {
        days.push(day);
      }
    });

    return days;
  };

  onDraft = () => {
    const listing_data = getListingData(
      this.state,
      this.props.user,
      this.props.institution
    );
    listing_data.status = "draft";
    delete listing_data.salary_type;
    // console.log(listing_data)

    // if draft id already saved, update instead of create
    if (this.state._id) {
      listing_data._id = this.state._id;
      API.updateListing(listing_data)
        .then((res) => {
          // console.log(res)
          notify.show("Draft saved successfully");
          this.setState({
            is_dirty: false,
          });
        })
        .catch((err) => {
          console.log(err.response);
          notify.show("Error saving draft");
        });
    } else {
      API.createListing(listing_data)
        .then((res) => {
          this.setState({ _id: res.data._id });
          notify.show("Draft saved successfully");
          this.setState({ is_dirty: false })
        })
        .catch((err) => {
          console.log(err.response);
          notify.show("Error saving draft");
        });
    }
    // }
  };

  onPreview = (e) => {
    e.preventDefault();
    const campus = this.props.campuses.find((c) => c._id === this.state.location) || {}
    let errors = validateForm(this.state, campus)

    if (!errors) {
      //form submission here
      let listing_data = getListingData(
        this.state,
        this.props.user,
        this.props.institution
      );
      listing_data._id = this.state._id;
      // console.log(listing_data)
      this.props.history.push("/PostJobPreview", {
        listing_data,
        type: "edit",
        confirmNav: true,
      });
    }
  };

  onCancel = () => {
    this.props.history.push(`/JobListing/${this.state._id}`);
  };

  onDelete = () => {
    API.deleteListing(this.state._id)
      .then((res) => {
        notify.show("Listing deleted successfully");
        this.props.history.push("/MyListings");
      })
      .catch((err) => {
        console.log(err.response);
        notify.show("Error deleting listing");
      });
  };

  render() {
    return (
      <CollegePageContainer header="Job Board" user={this.props.user}>
        <UnsavedChangesPopup
          is_dirty={this.state.is_dirty}
          exceptPathname="/PostJobPreview"
        />
        {
          this.state.qualificationList.length && this.state.levels.length && (
            <JobListingForm
              state={this.state}
              handleFormFieldChange={this.handleFormFieldChange}
              handleCheckboxChange={this.handleCheckboxChange}
              handleDateChange={this.handleDateChange}
              handleRemunerationChange={this.handleRemunerationChange}
              handleCurrencyValueChange={this.handleCurrencyValueChange}
              handleTagsChange={this.handleTagsChange}
              handleDeliveryModeChange={this.handleDeliveryModeChange}
              handleRadioChange={this.handleRadioChange}
              onDraft={this.onDraft}
              onSubmit={this.onPreview}
              onCancel={this.onCancel}
              onDelete={this.onDelete}
              // onPublish={this.onPublish}
              campuses={this.props.campuses}
              qualifications={this.state.qualificationList}
              levels={this.state.levels}
              selectedList={this.state.selected_tags}
              user={this.props.user}
            />
          )
        }
        {/* <ConfirmDelete
          state={this.state}
          onCancel={this.onCancel}
          onDelete={this.onDelete}
        /> */}
      </CollegePageContainer>
    );
  }
}

function mapStateToProps(state) {
  return {
    user: state.college.user,
    institution: state.college.institution,
    campuses: state.college.campuses,
  };
}

export default connect(mapStateToProps)(withRouter(EditListing));
